/* Copo de Luz — scripts propios (sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll ---------- */
  var observer = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.nv-reveal:not(.nv-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nv-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('nv-visible');
            e.target.dispatchEvent(new CustomEvent('nv:visible'));
            observer.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Nieve que cae ---------- */
  function initNieve(root) {
    (root || document).querySelectorAll('canvas.nv-nieve:not([data-ok])').forEach(function (cv) {
      cv.setAttribute('data-ok', '1');
      if (reduce) return;
      var ctx = cv.getContext('2d');
      var cantidad = parseInt(cv.dataset.cantidad || '90', 10);
      var velocidad = parseFloat(cv.dataset.velocidad || '1');
      var copos = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), activo = true;
      function size() {
        var r = cv.getBoundingClientRect();
        w = r.width; h = r.height;
        cv.width = w * dpr; cv.height = h * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      function nuevo(top) {
        return {
          x: Math.random() * w,
          y: top ? -10 : Math.random() * h,
          r: Math.random() * 2.4 + 0.6,
          vy: (Math.random() * 0.6 + 0.35) * velocidad,
          vx: Math.random() * 0.4 - 0.2,
          fase: Math.random() * Math.PI * 2,
          a: Math.random() * 0.6 + 0.35
        };
      }
      size();
      var n = w < 600 ? Math.round(cantidad * 0.55) : cantidad;
      for (var i = 0; i < n; i++) copos.push(nuevo(false));
      window.addEventListener('resize', size);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { activo = es[0].isIntersecting; if (activo) requestAnimationFrame(loop); }).observe(cv);
      }
      function loop() {
        if (!activo) return;
        ctx.clearRect(0, 0, w, h);
        for (var i = 0; i < copos.length; i++) {
          var c = copos[i];
          c.fase += 0.01;
          c.y += c.vy;
          c.x += c.vx + Math.sin(c.fase) * 0.3;
          if (c.y > h + 10 || c.x < -10 || c.x > w + 10) copos[i] = nuevo(true);
          ctx.beginPath();
          ctx.arc(c.x, c.y, c.r, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(244,241,234,' + c.a + ')';
          ctx.fill();
        }
        requestAnimationFrame(loop);
      }
      requestAnimationFrame(loop);
    });
  }

  /* ---------- Interruptor encender/apagar ---------- */
  function initInterruptor(root) {
    (root || document).querySelectorAll('[data-nv-enciende]:not([data-ok])').forEach(function (sec) {
      sec.setAttribute('data-ok', '1');
      var btn = sec.querySelector('.nv-interruptor');
      var escena = sec.querySelector('.nv-escena');
      var estado = sec.querySelector('.nv-escena__estado');
      var txt = sec.querySelector('.nv-interruptor__texto');
      if (!btn || !escena) return;
      function set(on) {
        escena.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (estado) estado.textContent = on ? estado.dataset.on : estado.dataset.off;
        if (txt) txt.textContent = on ? txt.dataset.on : txt.dataset.off;
      }
      btn.addEventListener('click', function () { set(!escena.classList.contains('is-on')); });
      if (sec.dataset.auto === 'true') {
        if (reduce || !('IntersectionObserver' in window)) { set(true); return; }
        var io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) { setTimeout(function () { set(true); }, 900); io.disconnect(); }
        }, { threshold: 0.5 });
        io.observe(escena);
      }
    });
  }

  /* ---------- Cifras que cuentan ---------- */
  function initCifras(root) {
    (root || document).querySelectorAll('[data-nv-cuenta]:not([data-ok])').forEach(function (el) {
      el.setAttribute('data-ok', '1');
      var fin = parseFloat(el.dataset.nvCuenta);
      var dec = parseInt(el.dataset.decimales || '0', 10);
      function fmt(v) { return v.toFixed(dec).replace('.', ','); }
      if (reduce || !('IntersectionObserver' in window)) { el.textContent = fmt(fin); return; }
      el.textContent = fmt(0);
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        var t0 = null, dur = 1600;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(fin * e);
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }

  /* ---------- Cuenta atrás ---------- */
  function initCuentaAtras(root) {
    (root || document).querySelectorAll('[data-nv-fecha]:not([data-ok])').forEach(function (el) {
      el.setAttribute('data-ok', '1');
      var partes = (el.dataset.nvFecha || '').split('-');
      if (partes.length !== 3) { el.style.display = 'none'; return; }
      var meta = new Date(+partes[0], +partes[1] - 1, +partes[2], 0, 0, 0).getTime();
      var cajas = el.querySelectorAll('b');
      function tick() {
        var d = meta - Date.now();
        if (d <= 0) { el.style.display = 'none'; return; }
        var v = [Math.floor(d / 864e5), Math.floor(d / 36e5) % 24, Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
        for (var i = 0; i < cajas.length; i++) cajas[i].textContent = (v[i] < 10 && i > 0 ? '0' : '') + v[i];
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-nv-producto]:not([data-ok])').forEach(function (sec) {
      sec.setAttribute('data-ok', '1');

      // Galería
      var principal = sec.querySelector('.nv-galeria__principal img');
      sec.querySelectorAll('.nv-galeria__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          if (!principal) return;
          sec.querySelectorAll('.nv-galeria__mini').forEach(function (m) { m.classList.remove('is-activa'); });
          mini.classList.add('is-activa');
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = mini.dataset.src;
            principal.srcset = '';
            principal.alt = mini.dataset.alt || '';
            principal.style.opacity = '1';
          }, 180);
        });
      });

      // Cantidad
      var qty = sec.querySelector('.nv-cantidad input');
      sec.querySelectorAll('.nv-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value || '1', 10) + (b.dataset.paso === '+' ? 1 : -1);
          qty.value = Math.max(1, v);
        });
      });

      // Variantes
      var datos = sec.querySelector('script[data-nv-variantes]');
      var input = sec.querySelector('input[name="id"]');
      var botones = sec.querySelectorAll('[data-nv-boton-compra]');
      var precio = sec.querySelectorAll('[data-nv-precio]');
      var antes = sec.querySelector('[data-nv-precio-antes]');
      if (datos && input) {
        var variantes = JSON.parse(datos.textContent);
        var formato = sec.dataset.formato || '${{amount}}';
        var moneda = function (cents) {
          var n = (cents / 100).toFixed(2).split('.');
          var miles = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          var conDec = miles + ',' + n[1];
          return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, conDec)
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
            .replace(/\{\{\s*amount\s*\}\}/, n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1]);
        };
        sec.querySelectorAll('.nv-variante input').forEach(function (r) {
          r.addEventListener('change', function () {
            var sel = [];
            sec.querySelectorAll('.nv-variante').forEach(function (fs) {
              var c = fs.querySelector('input:checked');
              sel.push(c ? c.value : null);
            });
            var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
            botones.forEach(function (b) {
              b.disabled = !v || !v.available;
              var t = b.querySelector('[data-nv-texto]') || b;
              t.textContent = !v ? b.dataset.noDisp : (v.available ? b.dataset.comprar : b.dataset.agotado);
            });
            if (!v) return;
            input.value = v.id;
            precio.forEach(function (p) { p.textContent = moneda(v.price); });
            if (antes) {
              if (v.compare_at_price && v.compare_at_price > v.price) { antes.textContent = moneda(v.compare_at_price); antes.hidden = false; }
              else antes.hidden = true;
            }
            if (v.featured_image && principal) { principal.src = v.featured_image.src; principal.srcset = ''; }
          });
        });
      }

      // Barra fija en móvil
      var barra = sec.querySelector('.nv-barra-movil');
      var ancla = sec.querySelector('.nv-cantidad-fila');
      if (barra && ancla && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var e = es[0];
          barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(ancla);
        barra.querySelector('.nv-btn').addEventListener('click', function () {
          var f = sec.querySelector('form.nv-form');
          if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
        });
      }
    });
  }

  function initTodo(root) {
    initReveals(root); initNieve(root); initInterruptor(root);
    initCifras(root); initCuentaAtras(root); initProducto(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();

  // Editor de Shopify: re-inicializar al cambiar una sección
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
